import { css } from '@emotion/react';
import { theme } from './theme';

export const globalStyles = css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
  
    font-family: ${theme.typography.fontFamily};
    line-height: ${theme.typography.body1.lineHeight};
    color: ${theme.colors.text.primary};
    background-color: ${theme.colors.background};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1 {
    font-size: ${theme.typography.h1.fontSize};
    font-weight: ${theme.typography.h1.fontWeight};
    line-height: ${theme.typography.h1.lineHeight};
    margin-bottom: ${theme.spacing.lg};
  }

  h2 {
    font-size: ${theme.typography.h2.fontSize};
    font-weight: ${theme.typography.h2.fontWeight};
    line-height: ${theme.typography.h2.lineHeight};
    margin-bottom: ${theme.spacing.md};
  }

  h3 {
    font-size: ${theme.typography.h3.fontSize};
    font-weight: ${theme.typography.h3.fontWeight};
    line-height: ${theme.typography.h3.lineHeight};
    margin-bottom: ${theme.spacing.md};
  }

  p {
    margin-bottom: ${theme.spacing.md};
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: ${theme.colors.secondary};
    }
  }

  button {
    font-family: ${theme.typography.fontFamily};
  }

  /* Responsive typography */
  @media (max-width: ${theme.breakpoints.md}) {
    h1 {
      font-size: calc(${theme.typography.h1.fontSize} * 0.85);
    }

    h2 {
      font-size: calc(${theme.typography.h2.fontSize} * 0.85);
    }

    h3 {
      font-size: calc(${theme.typography.h3.fontSize} * 0.85);
    }
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    h1 {
      font-size: calc(${theme.typography.h1.fontSize} * 0.7);
    }

    h2 {
      font-size: calc(${theme.typography.h2.fontSize} * 0.7);
    }

    h3 {
      font-size: calc(${theme.typography.h3.fontSize} * 0.7);
    }
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.background};
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  /* Toast notifications */
  .Toastify__toast {
    border-radius: ${theme.borderRadius.md};
    box-shadow: ${theme.shadows.md};
  }

  .Toastify__toast--success {
    background: ${theme.colors.success};
  }

  .Toastify__toast--error {
    background: ${theme.colors.error};
  }

  .Toastify__toast--warning {
    background: ${theme.colors.warning};
  }

  .Toastify__toast--info {
    background: ${theme.colors.info};
  }
`; 